<template>
  <div class="user-agreement">
    <p class="title">一、注册须知及流程</p>
    <p class="content">1、关注华发置业通进入“全民营销”；</p>
    <p class="content">
      2、根据系统指引，选择注册身份，经纪人必须提供本人真实、正确、最新及完整的资料，华发员工或业主类经纪人注册时，珠海华发实业股份有限公司将对经纪人个人资料（如身份证号码、手机号码等）进行核对校验，若检验不通过，则注册不成功。
    </p>
    <p class="title" style="margin-top:25px">二、特别声明</p>
    <p class="content">请您仔细阅读如下条款，并遵照执行：</p>
    <p class="content">
      1、当您注册为本平台的经纪人时，即意味着您接受本平台的所有规则和条款。当本平台的规则和条款变更时，变更后的规则和条款自动对您有约束力，珠海华发实业股份有限公司对此不再另行通知。
    </p>
    <p class="content">
      2、您的注册、登录行为即视为接受本平台的所有条款、规则（包括其今后更新、修改的条款）。请您妥善保管登录名、密码等信息，凡是以您的登录名、密码登录的任何行为均视为您本人的行为。若因登录名、密码被盗导致的任何后果或损失，将由您自行追究盗取人的责任，珠海华发实业股份有限公司可在合理范围内予以协助。
    </p>
    <p class="content">
      3、您登录平台登记被推介客户信息前，应保证已取得被推荐人的同意，确保珠海华发实业股份有限公司及其各项目开发公司不会因此遭受被推荐人的投诉、索赔，否则珠海华发实业股份有限公司有权终止您对本平台的使用，并要求您消除不利影响，赔偿珠海华发实业股份有限公司及其各下属公司因此遭受的损失。
    </p>
    <p class="content">
      4、每一项目的开发公司对推介行为的权利、义务可能会有所不同，请您务必自行与项目开发公司联系、确认，每一项目开发公司对此保留最终解释权。
    </p>
    <p class="content">
      5、您登录本网站进行任何行为均应符合各项法律规定，如果您的注册账号在本网站进行违法、违规行为，或遭受珠海华发实业股份有限公司下属公司客户投诉、遭受其他第三人举报经珠海华发实业股份有限公司确认属实的，珠海华发实业股份有限公司有权立即终止您的登录，同时冻结、注销您的账号。若您因此遭受任何损失，珠海华发实业股份有限公司对此不承担任何责任。
    </p>
    <p class="content">
      6、经纪人的姓名、手机号码、身份证号码、银行卡账号以及银行开户行作为佣金结算对象的凭证，若因经纪人的资料错误、不实，导致不能成功结算佣金的后果由经纪人自行承担。
    </p>
    <p class="content">
      7、您推荐的客户在推荐保护期内成功购买对应的项目房源，您将会获得项目所示佣金。项目开发公司会对您的推荐进行核实，核实后会进行佣金发放。（不同项目佣金规则不尽相同，请在推荐前仔细阅读项目佣金信息）。
    </p>
    <p class="content">
      8、注册用户的个人信息受法律保护，珠海华发实业股份有限公司承诺将采取一切力所能及的手段保护注册用户信息安全，不会非法收集、使用、加工、传输注册用户个人信息，不会非法买卖、提供或者公开注册用户个人信息。
    </p>
    <p class="content">
      9、珠海华发实业股份有限公司对本协议条款拥有最终解释权。
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {}
};
</script>
<style scoped lang="scss">
.user-agreement {
  margin: 14px 24px;
  .title {
    font-weight: bold;
    font-size: 16px;
    color: #222222;
    letter-spacing: 0;
    line-height: 26px;
    margin-top: 14px;
  }

  .content {
    font-size: 14px;
    color: #101010;
    letter-spacing: 0;
    line-height: 26px;
  }
}
</style>
